import type { ReduxStoreType } from 'Core/store';
import { isTruthy } from 'Utils/guards';

export type AddonInitialize = (store: ReduxStoreType) => void;

export type AddonAPI = {
  initialize?: AddonInitialize;
};

export type Feature = {
  enabled: boolean;
  name: string;
} & AddonAPI;

export type Addon = {
  name: string;
  features: string[];
} & AddonAPI;

export function combineAPI(...apiList: AddonAPI[]): AddonAPI {
  const getFromAPIsByKey = <K extends keyof AddonAPI>(key: K): Required<AddonAPI>[K][] =>
    apiList.map((api) => api[key]).filter(isTruthy);

  const initializers = getFromAPIsByKey('initialize');
  return {
    initialize: initializers.length ? (store) => initializers.forEach((init) => init(store)) : undefined,
  };
}

export function createAddon(name: string, coreAPI: AddonAPI, ...features: Feature[]): Addon {
  const enabledFeatures = features.filter((f) => f.enabled);
  return {
    name,
    features: enabledFeatures.map((f) => f.name),
    ...combineAPI(coreAPI, ...enabledFeatures),
  };
}
